// ==============================|| CITYZEN - FORMAT HELPERS (date-fns / ro) ||============================== //

// tabular figures for aligned dates / numbers
export const TNUM_SX = { fontVariantNumeric: 'tabular-nums' as const, fontFeatureSettings: '"tnum"' };
